import { User } from 'api/models';

export enum ProjectConversationPrivacy {
  Shared = 'SHARED',
  Private = 'PRIVATE',
}

export interface ProjectConversationPayloadSkelton {
  conversationName: string;
  conversationDescription: string;
  private?: boolean;
  addAllMembersToConversation?: boolean;
  addAllMembersToChannel?: boolean;
  project: {
    projectId: number;
  };
}

export interface ConversationMember {
  user: User;
  lastSeenCommentCreatedAt?: number;
  lastSeenCommentId?: number;
}
export interface BaseProjectConversation
  extends ProjectConversationPayloadSkelton {
  private: boolean;
  members?: ConversationMember[];
}

export interface ProjectConversation extends BaseProjectConversation {
  createdAt: number;
  createdBy: User;
  conversationId: number;
  partOfConversation: boolean;
  account: {
    accountId: number;
  };
  updatedBy: {
    userId: number;
    identityType: string;
  };
  unreadMessages: number;
}

export enum UpdateConversationFormItems {
  ConversationName = 'conversationName',
  ConversationDescription = 'conversationDescription',
  Private = 'private',
  AddAllMemberToChannel = 'addAllMemberToChannel',
  ProjectId = 'projectId',
}
export interface ProjectConversationFormPayload {
  [UpdateConversationFormItems.ConversationName]: string;
  [UpdateConversationFormItems.ConversationDescription]: string;
  [UpdateConversationFormItems.Private]: boolean;
  [UpdateConversationFormItems.AddAllMemberToChannel]: boolean;
  [UpdateConversationFormItems.ProjectId]: number;
}

export interface ProjectConversationLastSeenInfo {
  lastSeenAt: number;
  commentId: number;
}
